import React, { Component } from "react";
import Map from "../header/Map";
import axios from "axios";
import Modal from "./Modal";

export class EditarPresionesCaudales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectorActual: "",
      sectores: null,
      errorEditarSector: false,
      equipos: null,
      puntos: [],
      equiposMapa: [],
      mensajeError: "",
      modalVisible: false
    };
  }

  componentDidMount() {
    // formateo y guardo la informacion en el state
    this.guardarEstado();
  }

  componentDidUpdate(prevProps, prevState) {
    // vuelvo a formatear si se cambia de sector
    if (
      prevProps.sectores !== this.props.sectores ||
      prevState.sectorActual !== this.state.sectorActual
    ) {
      this.guardarEstado();
      this.setState({
        errorEditarSector: false,
        modalVisible: false
      });
    }
  }

  cargarPuntos(sectorActual) {
    if (sectorActual == "") {
      sectorActual = 0;
    }
    var equiposActual = [...this.state.sectores[sectorActual].equipos];
    var puntos = [];
    var equiposMapa = [];
    var keys = Object.keys(this.props.equipos);

    // guardo los datos de los puntos y equipos para usar en el mapa

    equiposActual.forEach(equipo => {
      keys.forEach((key, i) => {
        if (equipo.pkmonitoreo !== "" && key === equipo.pkmonitoreo) {
          equiposMapa.push({ [equipo.pkmonitoreo]: this.props.equipos[key] });
          var tipo = "";

          if (equipo.tipo === "ENTRADA" || equipo.tipo === "SALIDA") {
            if (this.props.equipos[key].macro === 1) {
              tipo = "caudalimetro";
            } else if (this.props.equipos[key].reguladora === 1) {
              tipo = "reguladora";
            }
          }
          if (equipo.tipo === "OTRO") {
            if (this.props.equipos[key].reguladora === 1) {
              tipo = "reguladora";
            }
          }
          if (equipo.tipo === "CRITICO") {
            if (this.props.equipos[key].reguladora === 1) {
              tipo = "reguladora";
            } else {
              tipo = "punto_medio";
            }
          }

          if (equipo.tipo === "MEDIO") {
            tipo = "punto_medio";
          }

          puntos.push({
            lat: this.props.equipos[key].latitud,
            lng: this.props.equipos[key].longitud,
            tipo
          });
        }
      });
    });

    return {
      puntos,
      equiposMapa
    };
  }

  guardarEstado() {
    // formateo los datos de forma que me sea mas comoda de manejar
    var keysE = Object.keys(this.props.equipos);
    var keysS = Object.keys(this.props.sectores);
    var equipos = [];
    var sectores = [];

    keysE.forEach((key, i) => {
      equipos.push(this.props.equipos[key]);
      equipos[i].pkmonitoreo = key;
    });
    keysS.forEach((key, i) => {
      sectores.push(this.props.sectores[key]);
      sectores[i].identificador = key;
    });

    this.setState({
      sectores,
      equipos
    });
  }

  handleSectorInputs(e) {
    var valor = e.target.value;
    var variable = e.target.name;
    var sectores = [...this.state.sectores];
    sectores[this.state.sectorActual][variable] = valor;
    // el ranc no puede ser menor a 0
    if (variable === "ranc" && parseFloat(valor) < 0) {
      return null;
    }

    this.setState({
      sectores
    });
  }

  changeSector(e) {
    var sectorActual = e.target.value;

    // cambio el sector actual por el seleccionado, actualizo los
    // puntos del mapa
    this.setState({
      sectorActual,
      puntos: this.cargarPuntos(sectorActual).puntos,
      equiposMapa: this.cargarPuntos(sectorActual).equiposMapa
    });
  }

  handleChangeSelect(index, e) {
    var valor = e.target.value;
    var sectores = [...this.state.sectores];
    sectores[this.state.sectorActual].equipos[index].pkmonitoreo = valor;
    // cambio el dato seleccionado y actualizo los puntos
    this.setState(
      {
        sectores
      },
      () => {
        this.setState({
          puntos: this.cargarPuntos(this.state.sectorActual).puntos,
          equiposMapa: this.cargarPuntos(this.state.sectorActual).equiposMapa
        });
      }
    );
  }

  addEquipo(tipo) {
    var sectores = [...this.state.sectores];
    var equipos = [
      ...sectores[this.state.sectorActual].equipos,
      { tipo, pkmonitoreo: "" }
    ];

    // agrego un equipo nuevo
    sectores[this.state.sectorActual].equipos = equipos;
    this.setState({
      sectores
    });
  }

  deleteEquipo(index) {
    var sectores = [...this.state.sectores];
    var equiposTipo = [...sectores[this.state.sectorActual].equipos];

    // quito el elemento segun su index, luego actualizo los puntos del mapa
    sectores[this.state.sectorActual].equipos = equiposTipo.filter(
      (equipo, i) => {
        return i !== index;
      }
    );
    this.setState(
      {
        sectores
      },
      () => {
        this.setState({
          puntos: this.cargarPuntos(this.state.sectorActual).puntos,
          equiposMapa: this.cargarPuntos(this.state.sectorActual).equiposMapa
        });
      }
    );
  }

  // confirmacion
  sendEditedSector() {
    const { sectores, sectorActual } = this.state;
    var configuraciones = "fci, expfugas, mt3xcon, caudalnocturnometa2, caudalnocturnometa, nombre, nroconexiones, extension, ranc".split(
      ", "
    );

    var error = false;
    configuraciones.forEach(config => {
      if (sectores[sectorActual][config] === "") {
        error = true;
      }
    });

    // reviso puntos sin seleccionar y repetidos
    var equipos = [...sectores[sectorActual].equipos];
    var pkmonitoreos = [];
    equipos.forEach(equipo => {
      if (
        equipo.pkmonitoreo === "" ||
        pkmonitoreos.indexOf(equipo.pkmonitoreo) !== -1
      ) {
        error = true;
      } else {
        pkmonitoreos.push(equipo.pkmonitoreo);
      }
    });

    // reviso puntos sin seleccionar
    equipos.forEach(equipo => {
      if (equipo.pkmonitoreo === "") {
        error = true;
      }
    });

    if (error) {
      this.setState(
        {
          errorEditarSector: true,
          mensajeError:
            "Debes llenar todos los campos correctamente, asegurate de no seleccionar un mismo equipo para varios puntos."
        },
        () => {
          document
            .querySelector(".parrafoerror")
            .scrollIntoView({ behavior: "smooth" });
        }
      );
      return null;
    } else {
      // formateo los datos para enviarlos
      var sectorCompleto = { ...sectores[sectorActual] };
      const { identificador } = sectorCompleto;
      delete sectorCompleto.identificador;

      configuraciones.forEach(config => {
        if (config !== "nombre") {
          sectorCompleto[config] = parseFloat(sectorCompleto[config]);
        }
      });

      var sectorFormateado = {
        ...sectorCompleto,
        action: "UPDATE",
        tiposector: "PQ",
        id: identificador
      };
    }

    this.setState({
      errorEditarSector: false
    });

    // convierto el dato en string y lo envio
    var texto = JSON.stringify(sectorFormateado);
    axios
      .get(`${this.props.url}?data=${texto}`)
      .then(res => {
        if (res.data.response === "OK") {
          this.props.toggle("");
          this.props.cargar();
          this.props.popup(
            true,
            true,
            "Los cambios han sido guardados con éxito"
          );
        } else if (res.data.response === "ERROR_RANC") {
          this.setState(
            {
              errorEditarSector: true,
              mensajeError:
                "El código Ranc ingresado ya está en uso por otro sector."
            },
            () => {
              document
                .querySelector(".parrafoerror")
                .scrollIntoView({ behavior: "smooth" });
            }
          );
        } else {
          this.props.cargar();
          this.props.popup(true, false, res.data.response);
        }
      })
      .catch(err => {
        this.props.cargar();
        this.props.popup(
          true,
          false,
          "Hubo un error, compruebe la conexión intente nuevamente."
        );
      });
  }

  recargar() {
    this.props.cargar();

    // reinicio la configuracion que llegaba del servidor
    setTimeout(() => {
      this.setState({
        puntos: this.cargarPuntos(this.state.sectorActual).puntos,
        equiposMapa: this.cargarPuntos(this.state.sectorActual).equiposMapa
      });
    }, 100);
  }

  deleteSector() {
    const { sectores, sectorActual } = this.state;

    var data = JSON.stringify({
      action: "DELETE",
      id: sectores[sectorActual].identificador,
      tiposector: "PQ"
    });

    this.toggleModal();

    axios
      .get(`${this.props.url}?data=${data}`)
      .then(res => {
        if (res.data.response === "OK") {
          this.props.toggle("");

          this.props.cargar();
          this.props.popup(
            true,
            true,
            `El sector ${sectores[sectorActual].nombre} se eliminó con éxito`
          );
        } else {
          this.props.cargar();
          this.props.popup(true, false, res.data.response);
        }
      })
      .catch(err => {
        this.props.cargar();
        this.props.popup(
          true,
          false,
          "Hubo un error al guardar los cambios, intente nuevamente."
        );
      });
  }

  toggleModal() {
    this.setState({
      modalVisible: !this.state.modalVisible
    });
  }

  render() {
    const {
      errorEditarSector,
      sectores,
      equipos,
      sectorActual,
      puntos,
      equiposMapa,
      mensajeError,
      modalVisible
    } = this.state;

    // inputs comunes
    var inputs = [
      { type: "text", name: "nombre", placeholder: "Nombre" },
      { type: "number", name: "extension", placeholder: "Extension de red" },
      { type: "number", name: "nroconexiones", placeholder: "Nro. conexiones" },
      { type: "number", name: "expfugas", placeholder: "Exp. fugas" },
      { type: "number", name: "fci", placeholder: "Fci" },
      {
        type: "number",
        name: "mt3xcon",
        placeholder: "Mt3xcon"
      },
      { type: "number", name: "ranc", placeholder: "Ranc" }
    ];

    if (!this.state.sectores || !this.state.equipos) {
      return null;
    }

    var contadores = [0, 0, 0, 0, 0];
    var cant = [0, 0, 0, 0, 0];
    var puntosTipo = [[], [], [], [], []];
    var tipos = "MEDIO, ENTRADA, SALIDA, CRITICO, OTRO".split(", ");
    // creo las variables para recorrerlas y asignarles puntos

    if (sectorActual !== "") {
      // reviso que clase de punto son
      tipos.forEach((tipo, i) => {
        sectores[sectorActual].equipos.forEach((equipo, k) => {
          if (equipo.tipo == tipo) {
            this.state.equipos.forEach(equiposState => {
              if (equiposState.pkmonitoreo === equipo.pkmonitoreo) {
                puntosTipo[i].push(equiposState);
              }
            });
          }
        });
        cant[i] = puntosTipo[i].length;
      });

      // si alguno de los puntos que no estan agregados cumplen los
      // parametros normales para ser esa clase de punto, los agrego

      const agregarPuntos = (i, equipo) => {
        var existencia = false;
        puntosTipo[i].forEach(punto => {
          if (punto && punto.pkmonitoreo === equipo.pkmonitoreo) {
            existencia = true;
          }
        });

        return existencia;
      };

      equipos.forEach((equipo, i) => {
        if (
          equipo.reguladora !== 1 &&
          equipo.macro !== 1 &&
          !agregarPuntos(0, equipo)
        ) {
          puntosTipo[0].push(equipo);
        }
        // agrego los puntos de entrada
        if (equipo.macro === 1 && !agregarPuntos(1, equipo)) {
          puntosTipo[1].push(equipo);
        }
        // los de salida
        if (equipo.macro === 1 && !agregarPuntos(2, equipo)) {
          puntosTipo[2].push(equipo);
        }
        // criticos
        if (!agregarPuntos(3, equipo)) {
          puntosTipo[3].push(equipo);
        }
        // otros
        if (!agregarPuntos(4, equipo)) {
          puntosTipo[4].push(equipo);
        }
      });
    }

    // filtro repetidos
    Array.prototype.unique = (function(a) {
      return function() {
        return this.filter(a);
      };
    })(function(a, b, c) {
      return c.indexOf(a, b + 1) < 0;
    });

    puntosTipo[0] = puntosTipo[0].unique();
    puntosTipo[1] = puntosTipo[1].unique();
    puntosTipo[2] = puntosTipo[2].unique();
    puntosTipo[3] = puntosTipo[3].unique();
    puntosTipo[4] = puntosTipo[4].unique();

    // filtro los sectores que si son de presiones y caudales

    var sectoresFiltrados = [];
    var indicesFiltrados = [];
    sectores.forEach((sector, i) => {
      var pertenece = false;
      var inicio = sector.identificador.substring(0, 3);
      if (inicio === "PQ_") {
        pertenece = true;
      }
      if (pertenece) {
        sectoresFiltrados.push(sector);
        indicesFiltrados.push(i);
      }
    });

    // retorno formulario
    return (
      <React.Fragment>
        {modalVisible ? (
          <Modal
            cancelar={this.toggleModal.bind(this)}
            delete={this.deleteSector.bind(this)}
          />
        ) : null}
        <div id="editarSector" className="inputs" data-simplebar>
          <p
            className="parrafoerror"
            style={{ display: errorEditarSector ? "block" : "none" }}
          >
            {mensajeError}
          </p>
          <select
            className="sectorSelector"
            value={sectorActual}
            onChange={this.changeSector.bind(this)}
          >
            <option value="">Selecciona un sector</option>
            {sectoresFiltrados.map((sector, index) => {
              return (
                <option key={index} value={indicesFiltrados[index]}>
                  {sector.nombre}
                </option>
              );
            })}
          </select>
          {sectorActual !== "" && equipos ? (
            <div>
              <div className="row editar">
                <div className="col-md-6">
                  <h3>Datos del sector</h3>
                  {inputs.map((input, i) => {
                    return (
                      <div key={i}>
                        <label>{input.placeholder}</label>
                        <input
                          type={input.type}
                          placeholder={input.placeholder}
                          name={input.name}
                          onChange={this.handleSectorInputs.bind(this)}
                          value={sectores[sectorActual][input.name]}
                          min="0"
                        />
                      </div>
                    );
                  })}
                  <div className="caudal">
                    <label>Caudal nocturno meta</label>
                    <div className="valores">
                      <div className="row">
                        <div className="col-2">
                          <label htmlFor="editGreen" className="green" />
                          <label htmlFor="editYellow" className="yellow" />
                          <label htmlFor="editRed" className="red" />
                        </div>
                        <div className="col-10">
                          <div className="data">
                            <span>&lt; =</span>
                            <input
                              type="number"
                              name="caudalnocturnometa"
                              onChange={this.handleSectorInputs.bind(this)}
                              value={sectores[sectorActual].caudalnocturnometa}
                              id="editGreen"
                            />{" "}
                          </div>
                          <div className="data">
                            <span>&lt; =</span>
                            <input
                              type="number"
                              name="caudalnocturnometa2"
                              onChange={this.handleSectorInputs.bind(this)}
                              value={sectores[sectorActual].caudalnocturnometa2}
                              id="editYellow"
                            />{" "}
                          </div>
                          <div className="data">
                            <span>> </span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 puntos">
                  <h3>Puntos del sector</h3>
                  <div className="medio">
                    <label>
                      Punto medio{" "}
                      <i
                        className="fas fa-plus"
                        onClick={this.addEquipo.bind(this, "MEDIO")}
                      />
                    </label>
                    {sectores[sectorActual].equipos.map((equipo, i) => {
                      if (equipo.tipo === "MEDIO") {
                        contadores[0]++;
                        return (
                          <div key={i}>
                            <span className="punto">M{contadores[0] - 1}</span>
                            <select
                              value={equipo.pkmonitoreo}
                              onChange={this.handleChangeSelect.bind(this, i)}
                              className={equipo.pkmonitoreo === "" ? "red" : ""}
                            >
                              <option value="">Selecciona un punto</option>
                              {puntosTipo[0].map((eq, indice) => {
                                return (
                                  <option key={indice} value={eq.pkmonitoreo}>
                                    {eq.ubicacion}
                                  </option>
                                );
                              })}
                            </select>
                            <i
                              className="fas fa-times"
                              onClick={this.deleteEquipo.bind(this, i)}
                            />
                          </div>
                        );
                      }
                    })}
                    {cant[0] < 1 ? (
                      <p className="mensaje">No hay puntos medios</p>
                    ) : null}
                  </div>
                  <div className="entrada">
                    <label>
                      Puntos de entrada{" "}
                      <i
                        className="fas fa-plus"
                        onClick={this.addEquipo.bind(this, "ENTRADA")}
                      />
                    </label>
                    {sectores[sectorActual].equipos.map((equipo, i) => {
                      if (equipo.tipo === "ENTRADA") {
                        contadores[1]++;
                        return (
                          <div key={i}>
                            <span className="punto">E{contadores[1] - 1}</span>
                            <select
                              key={i}
                              value={equipo.pkmonitoreo}
                              onChange={this.handleChangeSelect.bind(this, i)}
                              className={equipo.pkmonitoreo === "" ? "red" : ""}
                            >
                              <option value="">Selecciona un punto</option>
                              {puntosTipo[1].map((eq, indice) => {
                                return (
                                  <option key={indice} value={eq.pkmonitoreo}>
                                    {eq.ubicacion}
                                  </option>
                                );
                              })}
                            </select>
                            <i
                              className="fas fa-times"
                              onClick={this.deleteEquipo.bind(this, i)}
                            />
                          </div>
                        );
                      }
                    })}
                    {cant[1] < 1 ? (
                      <p className="mensaje">No hay puntos de entrada</p>
                    ) : null}
                  </div>

                  <div className="salida">
                    <label>
                      Puntos de salida{" "}
                      <i
                        className="fas fa-plus"
                        onClick={this.addEquipo.bind(this, "SALIDA")}
                      />
                    </label>
                    {sectores[sectorActual].equipos.map((equipo, i) => {
                      if (equipo.tipo === "SALIDA") {
                        contadores[2]++;
                        return (
                          <div key={i}>
                            <span className="punto">S{contadores[2] - 1}</span>
                            <select
                              key={i}
                              value={equipo.pkmonitoreo}
                              onChange={this.handleChangeSelect.bind(this, i)}
                              className={equipo.pkmonitoreo === "" ? "red" : ""}
                            >
                              <option value="">Selecciona un punto</option>
                              {puntosTipo[2].map((eq, indice) => {
                                return (
                                  <option key={indice} value={eq.pkmonitoreo}>
                                    {eq.ubicacion}
                                  </option>
                                );
                              })}
                            </select>
                            <i
                              className="fas fa-times"
                              onClick={this.deleteEquipo.bind(this, i)}
                            />
                          </div>
                        );
                      }
                    })}
                    {cant[2] < 1 ? (
                      <p className="mensaje">No hay puntos de salida</p>
                    ) : null}
                  </div>
                  <div className="critico">
                    <label>
                      Puntos críticos{" "}
                      <i
                        className="fas fa-plus"
                        onClick={this.addEquipo.bind(this, "CRITICO")}
                      />
                    </label>
                    {sectores[sectorActual].equipos.map((equipo, i) => {
                      if (equipo.tipo === "CRITICO") {
                        contadores[3]++;
                        return (
                          <div key={i}>
                            <span className="punto">C{contadores[3] - 1}</span>
                            <select
                              key={i}
                              value={equipo.pkmonitoreo}
                              onChange={this.handleChangeSelect.bind(this, i)}
                              className={equipo.pkmonitoreo === "" ? "red" : ""}
                            >
                              <option value="">Selecciona un punto</option>
                              {puntosTipo[3].map((eq, indice) => {
                                return (
                                  <option key={indice} value={eq.pkmonitoreo}>
                                    {eq.ubicacion}
                                  </option>
                                );
                              })}
                            </select>
                            <i
                              className="fas fa-times"
                              onClick={this.deleteEquipo.bind(this, i)}
                            />
                          </div>
                        );
                      }
                    })}
                    {cant[3] < 1 ? (
                      <p className="mensaje">No hay puntos críticos</p>
                    ) : null}
                  </div>
                  <div className="otros">
                    <label>
                      Otros puntos{" "}
                      <i
                        className="fas fa-plus"
                        onClick={this.addEquipo.bind(this, "OTRO")}
                      />
                    </label>
                    {sectores[sectorActual].equipos.map((equipo, i) => {
                      if (equipo.tipo === "OTRO") {
                        contadores[4]++;
                        return (
                          <div key={i}>
                            <span className="punto">O{contadores[4] - 1}</span>
                            <select
                              key={i}
                              value={equipo.pkmonitoreo}
                              onChange={this.handleChangeSelect.bind(this, i)}
                              className={equipo.pkmonitoreo === "" ? "red" : ""}
                            >
                              <option value="">Selecciona un punto</option>
                              {puntosTipo[4].map((eq, indice) => {
                                return (
                                  <option key={indice} value={eq.pkmonitoreo}>
                                    {eq.ubicacion}
                                  </option>
                                );
                              })}
                            </select>
                            <i
                              className="fas fa-times"
                              onClick={this.deleteEquipo.bind(this, i)}
                            />
                          </div>
                        );
                      }
                    })}
                    {cant[4] < 1 ? (
                      <p className="mensaje">
                        No hay puntos de otras categorías
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-12">
                  <div className="botonesConf crear">
                    <div className="row">
                      <div className="col-md-4">
                        <button
                          onClick={this.toggleModal.bind(this)}
                          className="delete"
                        >
                          Eliminar Sector
                        </button>
                      </div>

                      <div className="col-md-4">
                        {" "}
                        <button
                          onClick={this.recargar.bind(this)}
                          className="restaurar"
                        >
                          Restaurar configuración
                        </button>
                      </div>
                      <div className="col-md-4">
                        <button onClick={this.sendEditedSector.bind(this)}>
                          Guardar cambios
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Map equipos={equiposMapa} puntos={puntos} />
            </div>
          ) : (
            <div className="emptySec">
              <h3>
                No has seleccionado un sector, selecciona uno para ver y editar
                su configuración.
              </h3>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default EditarPresionesCaudales;
